import { type FormEvent, useState } from 'react';
import { useApi, useConsulta } from '@plataforma/web/api';
import { type Dominio, GuiaDominio } from './dominios/GuiaDominio';

export function MisDominios() {
  const api = useApi();
  const lista = useConsulta<Dominio[]>('/platform/mi-lotero/dominios');
  const [error, setError] = useState<string | null>(null);

  const accion = async (fn: () => Promise<unknown>) => {
    setError(null);
    try {
      await fn();
      lista.recargar();
    } catch (e) {
      setError((e as Error).message);
    }
  };
  const agregar = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const forma = e.currentTarget;
    const dominio = new FormData(forma).get('dominio');
    void accion(async () => {
      await api('POST', '/platform/mi-lotero/dominios', { dominio });
      forma.reset();
    });
  };
  return (
    <>
      <div className="encabezado">
        <div>
          <h1>Mi dominio</h1>
          <div className="subtitulo">Tu tienda en tu propio .com, con certificado automático</div>
        </div>
      </div>
      {error && <p className="error">{error}</p>}
      {(lista.datos ?? []).map((d) => (
        <section key={d.id} className="seccion">
          <header>
            <h2>{d.dominio}</h2>
            <div className="relleno" />
            <span className={`etiqueta ${d.verificado ? 'exito' : 'aviso'}`}>
              {d.tipo === 'subdominio'
                ? 'Subdominio'
                : d.verificado
                  ? 'Verificado'
                  : 'Sin verificar'}
            </span>
            {d.tipo === 'propio' && (
              <button
                className="boton chico"
                onClick={() =>
                  window.confirm(`¿Quitar ${d.dominio}? Tu tienda dejará de abrir ahí.`) &&
                  void accion(() => api('DELETE', `/platform/mi-lotero/dominios/${d.id}`))
                }
              >
                Quitar
              </button>
            )}
          </header>
          <div className="cuerpo">
            {d.tipo === 'subdominio' ? (
              <p className="subtitulo">
                Tu tienda siempre abre en{' '}
                <a href={`https://${d.dominio}/`} target="_blank" rel="noopener noreferrer">
                  {d.dominio}
                </a>
                , aunque también tengas tu propio dominio.
              </p>
            ) : (
              <GuiaDominio d={d} alCambiar={lista.recargar} />
            )}
          </div>
        </section>
      ))}
      <form className="seccion cuerpo formulario" onSubmit={agregar}>
        <label className="campo">
          <span>Agregar tu dominio (el que ya compraste)</span>
          <input name="dominio" required placeholder="www.mitienda.com" autoCapitalize="none" />
        </label>
        <div>
          <button className="boton">Agregar</button>
        </div>
      </form>
    </>
  );
}
